export function AffiliateDisclaimer() {
  return (
    <div className="text-xs text-gray-500 text-center">
      <p>
        We may earn an affiliate commission when you buy through our links. This never affects our reviews or comparisons.
      </p>
    </div>
  )
}
